import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { SipSetting } from 'data/sipSetting/sipSetting.types';
import { NetworkId } from 'data/networkId/networkId.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  sipSettingData: SipSetting,
  originalDigitExtractionServerFormData: SipSetting | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.SIP_SETTING_CREATE;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.SIP_SETTING_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(sipSettingData, null, isEdit, originalDigitExtractionServerFormData),
    sipSettingData.id,
    AuditService.SIP_SETTING,
    actionType,
  );
  return auditDetails as AuditDetails;
}

export function getNetworkAuditDetailsToSubmit(
  dialedDigitExtractionServerData: NetworkId,
  originalDigitExtractionServerFormData: NetworkId | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  const actionType = AuditActionType.NETWORK_ADD;
  const isEdit = false;

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.networkId,
    AuditService.NETWORK,
    actionType,
  );
  return auditDetails as AuditDetails;
}
